import React from 'react' ;
import BodyOfHome from "../Home/BodyOfHome";
// import Header from "../Common/Header";


class Home extends React.Component{
    render() {
        return (
            <div>
                {/* <Header/> */}
                <BodyOfHome/>

            </div>
        );
    }
}

export default Home;
